<template>
  <b-modal id="delete-rewards-modal" title="Delete Reward">
    <p class="modal-main-message">
      Are you sure you want delete selected rewards?
    </p>
    <div slot="modal-footer">
      <b-btn
        v-bind:disabled="loading"
        variant="ghost"
        class="mr-1 btn-cancel"
         @click="$root.$emit('bv::hide::modal', 'delete-rewards-modal')"
      >
        Cancel
      </b-btn>
      <b-btn
        v-bind:disabled="loading"
        variant="primary"
        class="ml-1"
        @click="$emit('deleteRewards')"
      >
        <template v-if="loading"> Deleting... </template>
        <template v-else> Yes, Delete </template>
      </b-btn>
      <span class="modal-helper-message d-block mt-4"
        >Caution: This cannot be undone.</span
      >
    </div>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "DeleteRewardsModal",
  props: ["selectedReward"],
  computed: {
    ...mapState("rewards", ["loading"]),
  },
};
</script>

<style scoped>
</style>